@if (isEditProjectLoading$ | async) {
  <app-page-loading></app-page-loading>
} @else {
  <div class="flex flex-1 h-full flex-col">
    <div
      class="font-semibold text-sm text-navy-600 pt-6 px-8 pb-10 w-full flex justify-between items-center box-border"
    >
      {{ isEdit ? 'Edit Project' : 'Add Project' }}
    </div>
    <div class="border-b border-solid border-navy-300 -mt-2"></div>

    <form class="flex flex-col h-full p-float-label flex-1 px-7 mt-5 overflow-hidden" #setupForm="ngForm">
      <ng-scrollbar #scrollbar appearance="native" class="std-scrollbar" orientation="vertical">
        <div [ngClass]="{ 'mr-3': scrollbar.isVerticallyScrollable() }">
          <app-floating-input
            [(ngModel)]="model.title"
            label="Title"
            name="title"
            placeholder="Title"
            required
          ></app-floating-input>

          <app-input-calendar
            [(date)]="model.start_date"
            [disabled]="false"
            [maxDate]="earliestLineItemDate"
            [minStartDate]="null"
            [required]="true"
            [showIcon]="true"
            iconTooltip="Start date needs to be before or equal the line item's budget or forecast start date!"
            name="start_date"
            placeholder="Project Start Date"
            (dateChange)="startDateChanged($event)"
          ></app-input-calendar>

          <app-dropdown
            (ngModelChange)="propertiesChanged($event)"
            [(ngModel)]="model.property_id"
            [options]="properties"
            label="Property Name"
            name="property_id"
            optionLabel="name"
            optionValue="id"
            required
          >
          </app-dropdown>

          <app-dropdown
            [(ngModel)]="model.status"
            [options]="projectStatuses"
            label="Project Status"
            name="status"
            optionLabel="name"
            optionValue="id"
            required
          >
            <ng-template #optionContent #selectedContent let-status>
              <div class="flex items-center gap-2">
                @if (status?.name) {
                  <span
                    [ngClass]="{
                      'bg-blue-600': status?.key === PROJECT_STATUS_KEY.IN_PROGRESS,
                      'bg-green-400': status?.key === PROJECT_STATUS_KEY.COMPLETED,
                      'bg-straw': status?.key === PROJECT_STATUS_KEY.PLANNED,
                      'bg-purple-700': status?.key === PROJECT_STATUS_KEY.CANCELED,
                      'bg-tinted-grey': status?.key === PROJECT_STATUS_KEY.ARCHIVED,
                      'bg-yellow-500': status?.key === PROJECT_STATUS_KEY.BIDDING,
                      'bg-green-600': status?.key === PROJECT_STATUS_KEY.AWARDED,
                      'bg-red-200': status?.key === PROJECT_STATUS_KEY.ON_HOLD,
                      'bg-color_cancel':
                        status?.key === PROJECT_STATUS_KEY.CANCELED || status?.key === PROJECT_STATUS_KEY.DELETED
                    }"
                    class="circle"
                  ></span>
                }
                <span class="capitalize">{{ status?.name }}</span>
              </div>
            </ng-template>
          </app-dropdown>

          <app-tag-input
            [(ngModel)]="model.tags"
            label="Project Tags"
            toolTip="You can utilize this field to tag your project with different comma-separated keywords which you can use to filter and group projects by different categories, ie. CapEx, OpEx, Maintenance...etc."
            name="tags"
          ></app-tag-input>

          <app-floating-input
            [(ngModel)]="model.custom_project_id"
            (inputBlurred)="customIdChanged($event)"
            [disabled]="!customIdEditable || !model.property_id || !model.start_date"
            label="Project ID"
            placeholder="Project ID"
            name="custom_project_id"
            required
            [minLength]="3"
            [maxLength]="16"
            [iconClass]="
              !model.property_id || !model.start_date ? '' : customIdEditable ? 'icon-text-revert' : 'icon-text-edit'
            "
            (iconClick)="onCustomIdIconClick()"
            [appTooltip]="!model.property_id || !model.start_date ? 'Please select property and start date first.' : ''"
          ></app-floating-input>
        </div>
      </ng-scrollbar>
      <div class="flex items-center justify-between mb-7 mt-4 gap-4">
        @if (model?.id) {
          <button type="button" (click)="deleteProject()" class="delete-button" aria-hidden="true">Delete</button>
        }
        <button
          type="submit"
          (click)="saveClicked()"
          (keyup.enter)="saveClicked()"
          [ngClass]="{ 'bg-yellow-500 ml-auto': !model?.id, 'bg-blue-700': !!model?.id }"
          class="rounded text-color-white py-1 px-10 font-semibold text-sm cursor-pointer"
        >
          {{ !!model?.id ? 'Update' : 'Post' }}
        </button>
      </div>
    </form>
  </div>
}
